/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useInitializeSession } from '@/modules/AiAgents/apiHooks';
import { AIChatContainer } from '@/modules/AiAgents/components/Agents/Nugz/AIChatContainer';
import { AIFieldsTableContainer } from '@/modules/AiAgents/components/Agents/Nugz/Fields/AIFieldsTableContainer';
import { AIContext } from '@/modules/AiAgents/context/nugzContext/context';
import { AIActionsTypes } from '@/modules/AiAgents/context/nugzContext/reducer';
import { useStore } from '@/shared/hooks/context/createGenericContext';

// TODO: refactor this to accept the kind of APIs to use, text, and table columns
// TODO: create handler for sening and responding messages - hook
const AIChatBot = () => {
  const { t } = useTranslation('common');
  const [selectedAsset] = useStore((store) => store?.asset);
  const { dispatch } = useContext(AIContext);

  const { isSuccess, isLoading, data } = useInitializeSession(
    selectedAsset?.id
  );

  useEffect(() => {
    if (isSuccess && selectedAsset) {
      dispatch({
        payload: [
          {
            senderName: t('nugz'),
            text: t('ai-starter-message'),
            timestamp: new Date(),
            type: 'receiver',
          },
        ],
        type: AIActionsTypes.setMessagesList,
      });
      dispatch({
        type: AIActionsTypes.setAreaUnit,
        payload: data.areaUnit,
      });
    }
  }, [isSuccess]);

  useEffect(() => {
    dispatch({
      payload: isLoading,
      type: AIActionsTypes.setIsLoading,
    });
  }, [isLoading]);

  return (
    <div className='flex h-full w-full gap-16 py-24'>
      <AIChatContainer />
      <AIFieldsTableContainer />
    </div>
  );
};

export { AIChatBot };
